const Preferences = () => {
    const title = 'Preferences';
    return <h1 className="mb-2 text-[2.5rem] font-medium">{title}</h1>;
};
export default Preferences;
